import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { auth } from "../services/auth";
import avatar from "../assets/images/avatar.png";
import styles from "../css/sidebar.module.css";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const userData = auth().getUser();
  const isAdmin = auth().isAdmin();

  const logout = () => {
    auth().logout();
    navigate("/");
    window.location.reload(false);
  };

  React.useEffect(() => {
    if (!userData) {
      navigate("/login");
    }
  }, [userData, navigate]);

  return (
    <aside className="border border-gray-350 rounded-3xl py-5">
      {/* <img className="relative -top-20 mx-auto" src={avatar} alt={userData?.name} /> */}
      <h2 className="text-center font-semibold">
        {userData?.firstName} {userData?.lastName}
      </h2>
      <p className="text-center font-light py-1">{userData?.email}</p>
      <section className="flex flex-col py-5">
        {isAdmin ? (
          <>
            <section className="flex flex-col py-1 mx-3 my-5 border-2 border-gray-50 shadow-md rounded-xl">
              <Link
                className={`mx-auto py-1 text-center ${styles.sidebarLink} ${
                  location.pathname === "/previewUsers" ? "text-pink-350" : ""
                }`}
                to="/previewUsers"
              >
                Users Preview
              </Link>
              <Link
                className={`mx-auto py-1 text-center ${styles.sidebarLink} ${
                  location.pathname === "/items" ? "text-pink-350" : ""
                }`}
                to="/items"
              >
                Items
              </Link>
              <Link
                className={`mx-auto py-1 text-center ${styles.sidebarLink} ${
                  location.pathname === "/updateMenu" ? "text-pink-350" : ""
                }`}
                to="/updateMenu"
              >
                Services Menu
              </Link>
              <Link
                className={`mx-auto py-1 text-center ${styles.sidebarLink} ${
                  location.pathname === "/ServicesPage" ? "text-pink-350" : ""
                }`}
                to="/ServicesPage"
              >
                Service Page
              </Link>
            </section>
          </>
        ) : null}
        <Link
          className={`mx-auto py-1 text-center ${styles.sidebarLink} ${
            location.pathname === "/helpDesk" ? "text-pink-350" : ""
          }`}
          to="/helpDesk"
        >
          Help Desk
        </Link>
        <Link
          className={`mx-auto py-1 text-center ${styles.sidebarLink} ${
            location.pathname === "/orders" ? "text-pink-350" : ""
          }`}
          to="/orders"
        >
          Order History
        </Link>
        <Link
          className={`mx-auto py-1 text-center ${styles.sidebarLink} ${
            location.pathname === "/billing" ? "text-pink-350" : ""
          }`}
          to="/billing"
        >
          Billing
        </Link>
        <Link
          className={`mx-auto py-1 text-center ${styles.sidebarLink} ${
            location.pathname === "/settings" ? "text-pink-350" : ""
          }`}
          to="/settings"
        >
          Account Settings
        </Link>
        <button className={`mx-auto py-1 text-center ${styles.sidebarLink}`} onClick={logout}>
          Logout
        </button>
      </section>
    </aside>
  );
}
